export default "__VITE_ASSET__DtvuA2c0__";